<main class="auth-page" [class.is-medi3]="isMedi3" [class.is-agil]="isAgil" [class.is-mdco]="isDinHms">
  <section class="auth-brand-panel" aria-labelledby="recovery-story-title">
    <header class="auth-header">
      <img
        *ngIf="!isMedi3 && !isAgil && !isDinHms"
        class="auth-brand"
        src="assets/images/KubaLogowhite.png"
        alt="Kuba"
      />
      <img
        *ngIf="isMedi3"
        class="auth-brand auth-medi3-logo"
        src="assets/images/Medi3Logo.svg"
        alt="Medi3"
      />
      <img
        *ngIf="isAgil"
        class="auth-brand auth-agil-logo"
        src="assets/icons/agil-logo.png"
        alt="Agil Helse"
      />
      <img
        *ngIf="isDinHms"
        class="auth-brand auth-mdco-logo"
        src="assets/images/mdco/wordmark-white.svg"
        alt="MDCO"
      />
    </header>
    <div class="auth-story">
      <div class="auth-eyebrow">
        <span aria-hidden="true"></span
        >{{ "PASSWORD_RECOVERY.EYEBROW" | translate }}
      </div>
      <h1
        id="recovery-story-title"
        class="auth-recovery-title"
        [innerHTML]="'PASSWORD_RECOVERY.STORY_TITLE' | translate"
      ></h1>
      <p class="auth-intro">
        {{ storyIntroKey | translate }}
      </p>
    </div>
    <div *ngIf="!isMedi3" class="auth-brand-bottom">
      <figure *ngIf="!isMedi3 && !isAgil && !isDinHms" class="auth-mascot" aria-hidden="true">
        <img src="assets/images/kuba-mascot.svg" alt="" />
      </figure>
      <footer class="auth-footer">
        <p class="auth-story-foot">{{ "LOGIN_DESIGN.FOOTER" | translate }}</p>
        <!-- Agil has no published terms page, so it shows the two links it has. -->
        <div class="auth-legal" *ngIf="isAgil; else kubaLegal">
          <a href="https://agilhelse.no" target="_blank" rel="noopener noreferrer"
            >Agil Helse AS</a
          >
          <a
            href="https://agilhelse.no/personvern/"
            target="_blank"
            rel="noopener noreferrer"
            >{{ "LOGIN_DESIGN.PRIVACY" | translate }}</a
          >
        </div>
        <ng-template #kubaLegal>
          <div class="auth-legal">
            <span>Kuba Norge AS</span>
            <a
              href="https://kuba.no/personvernerklaering/"
              target="_blank"
              rel="noopener noreferrer"
              >{{ "LOGIN_DESIGN.PRIVACY" | translate }}</a
            >
            <a
              href="https://kuba.no/vilkar/"
              target="_blank"
              rel="noopener noreferrer"
              >{{ "LOGIN_DESIGN.TERMS" | translate }}</a
            >
          </div>
        </ng-template>
      </footer>
    </div>
  </section>
  <section class="auth-panel" aria-labelledby="recovery-title">
    <nav
      class="auth-language"
      [attr.aria-label]="'LOGIN_DESIGN.LANGUAGE' | translate"
    >
      <button
        type="button"
        (click)="setLanguage('no')"
        [attr.aria-pressed]="currentLang === 'no'"
        aria-label="Norsk"
        title="Norsk"
        lang="no"
      >
        <img *ngIf="!isAgil" src="assets/images/norsk.png" alt="" aria-hidden="true" />
        <span *ngIf="isAgil" aria-hidden="true">NO</span>
      </button>
      <button
        type="button"
        (click)="setLanguage('en')"
        [attr.aria-pressed]="currentLang === 'en'"
        aria-label="English"
        title="English"
        lang="en"
      >
        <img *ngIf="!isAgil" src="assets/images/english.png" alt="" aria-hidden="true" />
        <span *ngIf="isAgil" aria-hidden="true">EN</span>
      </button>
    </nav>
    <div class="auth-card">
      <ng-container *ngIf="!mailSent; else confirmation">
        <a
          class="auth-link auth-back"
          [routerLink]="['../login']"
          queryParamsHandling="preserve"
        >
          <i class="pi pi-arrow-left" aria-hidden="true"></i
          >{{ "PASSWORD_RECOVERY.BACK_LOGIN" | translate }}
        </a>
        <h2 id="recovery-title">{{ "PASSWORD_RECOVERY.TITLE" | translate }}</h2>
        <p
          class="auth-card-intro auth-recovery-intro"
          [innerHTML]="'PASSWORD_RECOVERY.INTRO' | translate"
        ></p>
        <form
          class="auth-form"
          [formGroup]="ForgotPasswordForm"
          (ngSubmit)="sendMail()"
          [attr.aria-busy]="loading"
          novalidate
        >
          <p-message
            *ngIf="isNotValid"
            severity="error"
            styleClass="auth-error"
            >{{ (resendSeconds > 0 ? "PASSWORD_RECOVERY.RATE_LIMIT" : "PASSWORD_RECOVERY.ERROR") | translate: { seconds: resendSeconds } }}</p-message
          >
          <div formGroupName="checkUser" class="auth-field">
            <label for="recovery-username">{{ "PASSWORD_RECOVERY.IDENTIFIER" | translate }}</label>
            <input
              pInputText
              id="recovery-username"
              type="text"
              formControlName="username"
              autocomplete="username"
              autocapitalize="none"
              spellcheck="false"
              required
              maxlength="254"
              [readonly]="loading"
              [invalid]="
                ForgotPasswordForm.get('checkUser.username').touched &&
                ForgotPasswordForm.get('checkUser.username').invalid
              "
              [attr.aria-describedby]="
                ForgotPasswordForm.get('checkUser.username').touched &&
                ForgotPasswordForm.get('checkUser.username').invalid
                  ? 'recovery-username-help'
                  : null
              "
            />
            <small
              id="recovery-username-help"
              class="auth-field-error"
              *ngIf="
                ForgotPasswordForm.get('checkUser.username').touched &&
                ForgotPasswordForm.get('checkUser.username').invalid
              "
              role="alert"
              >{{ "PASSWORD_RECOVERY.IDENTIFIER_REQUIRED" | translate }}</small
            >
          </div>
          <p-button
            type="submit"
            [label]="
              resendSeconds > 0
                ? ('PASSWORD_RECOVERY.RESEND_WAIT' | translate: { seconds: resendSeconds })
                : ('PASSWORD_RECOVERY.SEND' | translate)
            "
            [loading]="loading"
            [disabled]="loading || resendSeconds > 0"
            icon="pi pi-arrow-right"
            iconPos="right"
            styleClass="auth-submit"
          />
        </form>
      </ng-container>
      <ng-template #confirmation>
        <div class="auth-confirmation" role="status" aria-live="polite">
          <img
            class="auth-email-illustration"
            src="assets/icons/send-email.png"
            width="512"
            height="512"
            alt=""
            aria-hidden="true"
          />
          <h2 id="recovery-title">
            {{ "PASSWORD_RECOVERY.CHECK_INBOX" | translate }}
          </h2>
          <p class="auth-card-intro">
            {{ "PASSWORD_RECOVERY.CONFIRMATION" | translate }}
          </p>
        </div>
        <div class="auth-recovery-help">
          <h3>{{ "PASSWORD_RECOVERY.NO_EMAIL" | translate }}</h3>
          <p>{{ "PASSWORD_RECOVERY.CHECK_SPAM" | translate }}</p>
        </div>
        <p-button
          type="button"
          (onClick)="resendMail()"
          [disabled]="resendSeconds > 0 || loading"
          [label]="
            resendSeconds > 0
              ? ('PASSWORD_RECOVERY.RESEND_WAIT'
                | translate: { seconds: resendSeconds })
              : ('PASSWORD_RECOVERY.RESEND' | translate)
          "
          icon="pi pi-refresh"
          styleClass="auth-resend"
        />
        <div class="auth-recovery-actions">
          <button type="button" class="auth-link" (click)="clear()">
            {{ "PASSWORD_RECOVERY.TRY_ANOTHER" | translate }}
          </button>
          <a
            class="auth-link"
            [routerLink]="['../login']"
            queryParamsHandling="preserve"
            >{{ "PASSWORD_RECOVERY.BACK_LOGIN" | translate }}</a
          >
        </div>
      </ng-template>
      <div *ngIf="!isMedi3" class="auth-support">
        <span>{{ "LOGIN_DESIGN.HELP" | translate }}</span>
        <a
          class="auth-link"
          [href]="isAgil ? 'https://agilhelse.no/kontakt-oss/' : 'https://kuba.no/kontakt/'"
          target="_blank"
          rel="noopener noreferrer"
          >{{ "LOGIN_DESIGN.CONTACT" | translate
          }}<i class="pi pi-arrow-up-right" aria-hidden="true"></i
        ></a>
      </div>
    </div>
  </section>
</main>
